import './styles.css';
import { mountApp } from './app.js';

mountApp();
